import React from "react";

const CopyIcon = ({ width = 16, height = 19, fill = "#6C757D", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.30775 15C4.80258 15 4.375 14.825 4.025 14.475C3.675 14.125 3.5 13.6974 3.5 13.1923V1.80775C3.5 1.30258 3.675 0.875 4.025 0.525C4.375 0.175 4.80258 0 5.30775 0H13.6923C14.1974 0 14.625 0.175 14.975 0.525C15.325 0.875 15.5 1.30258 15.5 1.80775V13.1923C15.5 13.6974 15.325 14.125 14.975 14.475C14.625 14.825 14.1974 15 13.6923 15H5.30775ZM5.30775 13.5H13.6923C13.7692 13.5 13.8398 13.4679 13.9038 13.4038C13.9679 13.3398 14 13.2692 14 13.1923V1.80775C14 1.73075 13.9679 1.66025 13.9038 1.59625C13.8398 1.53208 13.7692 1.5 13.6923 1.5H5.30775C5.23075 1.5 5.16025 1.53208 5.09625 1.59625C5.03208 1.66025 5 1.73075 5 1.80775V13.1923C5 13.2692 5.03208 13.3398 5.09625 13.4038C5.16025 13.4679 5.23075 13.5 5.30775 13.5ZM1.80775 18.5C1.30258 18.5 0.875 18.325 0.525 17.975C0.175 17.625 0 17.1974 0 16.6923V3.80775H1.5V16.6923C1.5 16.7693 1.53208 16.8398 1.59625 16.9038C1.66025 16.9679 1.73075 17 1.80775 17H11.6923V18.5H1.80775Z"
        fill={fill}
      />
    </svg>
  );
};

export default CopyIcon;

